module.exports = __webpack_public_path__ + "static/Leaf_1_Beer_Animations_1-fbf3e8d7ab9678b4c483510657be07a0.png";